import { render, staticRenderFns } from "./PaceOfPlay.vue?vue&type=template&id=1a0a5f25&"
import script from "./PaceOfPlay.vue?vue&type=script&lang=js&"
export * from "./PaceOfPlay.vue?vue&type=script&lang=js&"
import style0 from "./PaceOfPlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports